import { useSelector } from 'react-redux'
import { ResourceHook } from 'modules/types'
import InventoryOutTransferRequestActions from './duck'
import InventoryOutTansferSelectors from './selectors'
import { useAction, usePageQuery } from '@agro-club/frontend-shared'
import { useEffect } from 'react'
import AuthSelectors from '../auth/selectors'
import { InventoryTransferRequest } from '../inventoryInTransferRequest/types'

// TODO refactor to allow to pass filter directrly
export const useInventoryOutTransferRequestList: ResourceHook<InventoryTransferRequest[], void[]> = () => {
  const progress = useSelector(InventoryOutTansferSelectors.listFetchProgress)
  const list = useSelector(InventoryOutTansferSelectors.list)
  const page = usePageQuery()
  const fetchAction = useAction(InventoryOutTransferRequestActions.listRequested, page ? { page } : {})
  const filterUpdated = useAction(InventoryOutTransferRequestActions.filterUpdated)
  const filterValue = useSelector(InventoryOutTansferSelectors.filter)
  const userCompany = useSelector(AuthSelectors.userCompany)
  useEffect(() => {
    const companyIds = userCompany ? [userCompany.id] : undefined
    if (!companyIds) return
    // retailer_to means after request was approved transfer items to this retailer
    filterUpdated({ ...filterValue, ...{ retailer_to: companyIds } })
    fetchAction()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterUpdated, userCompany])

  return [progress, list]
}
